import Container from '@mui/material/Container';
import {
  isRouteErrorResponse,
  Link as RouterLink,
  useRouteError,
} from 'react-router-dom';

import { ApiError } from '@/api/envelope';
import { Button } from '@/components/ui/Button';
import { StatusPage } from '@/features/errors/StatusPage';

import { ROUTES } from '../routes';

/**
 * Shown when a route throws, or an address outside the portal frame matches
 * nothing. An unknown address inside the frame gets the not-found page there
 * instead, with the navigation still around it.
 *
 * Its own main landmark, because it renders where the layout itself may be
 * what failed.
 */
export function ErrorRoute() {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${String(error.status)} ${error.statusText}`
    : 'Something went wrong';

  // Only a sentence the backend wrote for people is shown. A thrown
  // programming error reads as what it is - a fault - not as its message,
  // which was written for a developer and names nothing the person can act on.
  const detail = isRouteErrorResponse(error)
    ? 'That page does not exist.'
    : error instanceof ApiError
      ? error.message
      : 'An unexpected error occurred.';
  if (!isRouteErrorResponse(error) && !(error instanceof ApiError)) {
    console.error(error);
  }

  return (
    <Container component="main" id="main" maxWidth="sm" sx={{ py: 8 }}>
      <StatusPage
        title={title}
        documentTitle={title}
        testId="error-route"
        action={
          <Button
            component={RouterLink}
            to={ROUTES.home}
            variant="secondary"
            data-testid="error-route-home-link"
          >
            Back to the start
          </Button>
        }
      >
        {detail}
      </StatusPage>
    </Container>
  );
}
